module.exports = __webpack_public_path__ + "static/media/avatar.498e6f94.png";